export const workflowDefinitionVersionsEndpoint = workflowDefinitionId =>
    `/api/workflow-definitions/${encodeURIComponent(workflowDefinitionId)}/versions`;

export const toWorkflowDefinitionVersionOptions = summaryList => (summaryList || []).filter(summary => summary?.disabled !== true).filter(summary => summary?.version !== null && summary?.version !== undefined).map(summary => ({
    value: String(summary.version),
    label: `Version ${summary.version}`,
}));

export const toWorkflowDefinitionVersionResults = summaryList => ({
    success: true,
    results: toWorkflowDefinitionVersionOptions(summaryList).map(option => ({
        value: option.value,
        name: option.label,
    })),
});
